import React from 'react'

export default function HeaderInfo({section}) {
  return (
    <div className="header__info title">
        <span>POKéMON INFO</span>
    </div>
  )
}
